import React from 'react';
import { BlurredContainerM3030 } from '../../../../components/containers/containers';
import DonutChart from '../../../../components/data-viewers/charts/donut-chart/donut-chart';
import { HorizontalSeparator, VerticalSeparator } from '../../../../components/ui-utils/separators';
import { formatNumber } from '../../../../helpers/number-formatters';
import { Slice } from '../../../../logic/graphql/types/types';
import { ChartWrapper, COLORS, INNER_COLORS, Legend } from './components';
import CenteredSpinner from '../../../../components/loading-indicators/centered-spinner';
import { useSelector } from 'react-redux';
import Presentation from '../../../../logic/redux/presentation';
import { ScreenSize } from '../../../../styles/screen-sizes';
import { withErrorBoundary } from '@sentry/react';
import { Fallback } from '../../../../components/utils/error-boundary';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';

const FlexContainer = styled.div`
  flex-direction: row;
  @media (max-width: 1400px) {
    flex-direction: column;
  }
`;

const SumPortfolio = (props: {
  sumPortfolioSlices?: Slice[];
  sum?: number;
  loading?: boolean;
}): JSX.Element => {
  const screenSize = useSelector(Presentation.select.selectScreenSize);
  const isMobile = screenSize === ScreenSize.XS;

  if (props.loading) {
    return (
      <BlurredContainerM3030 className="w-1/1 mb-6">
        <CenteredSpinner />
      </BlurredContainerM3030>
    );
  }
  return (
    <BlurredContainerM3030 className="w-1/1 mb-6">
      <div className="w-1/1 flex flex-row justify-between mb-2">
        <h3>
          <FormattedMessage id="dashboardPage.portfolioSummary.title" />
        </h3>
        <div className="flex flex-col items-end">
          <span className="text-18 text-right">
            <b className="text-blue">{formatNumber(props.sum)}</b> HUF
          </span>
          <span className="text-8 text-gray">
            <FormattedMessage id="dashboardPage.portfolioSummary.roundedValue" />
          </span>
        </div>
      </div>
      <FlexContainer className="w-1/1 flex">
        <div className="flex-initial flex items-center justify-center">
          <ChartWrapper className="flex-initial">
            {props.sumPortfolioSlices ? (
              <DonutChart
                data={props.sumPortfolioSlices.filter((s) => s.value > 0)}
                colors={COLORS}
                innerColors={INNER_COLORS}
                small={isMobile}
              />
            ) : null}
          </ChartWrapper>
        </div>
        <VerticalSeparator className="flex-none hidden xl:block mx-4" />
        <HorizontalSeparator className="flex-none block xl:hidden my-4" />
        <Legend sumPortfolioSlices={props.sumPortfolioSlices?.filter((s) => s.value > 0)} />
      </FlexContainer>
    </BlurredContainerM3030>
  );
};

export default withErrorBoundary(SumPortfolio, { fallback: Fallback });
